import React from 'react';

const DecisionFramingSection = () => {
  return (
    <section className="section-padding-sm bg-[var(--bg-primary)]">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          {/* Main Statement */}
          <h2 className="heading-1 mb-8">
            Most families already have insurance.
            <span className="block mt-2 text-[var(--text-secondary)]">
              What they lack is protection architecture.
            </span>
          </h2>
          
          <div className="divider mx-auto mb-10"></div>
          
          {/* Three Reasons */}
          <p className="body-large text-[var(--text-primary)] mb-6">
            Protection decisions fail for three reasons:
          </p>
          
          <ul className="space-y-3 mb-10 max-w-xl mx-auto text-left">
            <li className="flex items-start">
              <span className="text-[var(--gold-primary)] mr-3 mt-1">•</span>
              <span className="body-regular text-[var(--text-secondary)]">fragmented policies</span>
            </li>
            <li className="flex items-start">
              <span className="text-[var(--gold-primary)] mr-3 mt-1">•</span>
              <span className="body-regular text-[var(--text-secondary)]">unclear responsibility coverage</span>
            </li>
            <li className="flex items-start">
              <span className="text-[var(--gold-primary)] mr-3 mt-1">•</span>
              <span className="body-regular text-[var(--text-secondary)]">no one verifying the structure</span>
            </li>
          </ul>
          
          {/* Solution Statement */}
          <p className="body-large text-[var(--text-primary)] mb-6">
            Protection Guardianship™ solves this with structured protection architecture.
          </p>
          
          {/* Closing Line */}
          <p className="body-regular text-[var(--text-secondary)] italic">
            The pathway below shows how families move from confusion → certainty.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DecisionFramingSection;
